import React from "react";
import {
  getFontFamily,
  getFontSize,
  getTextColor,
} from "../../../service/ui/UI";
import UtilityHelper from "../../../service/utilities/UtilityHelper";

type Props = {
  className?: string;
  role?: string;
  children?: React.ReactNode;
  style?: any;
  color?: string;
  fontName?: string;
  fontSize?: string;
};

const fontNameClass = (
  fontName: string,
  fontSize: string = "",
  color: string = ""
): string => {
  let classes: Array<string> = [];
  const fontNameClass = getFontFamily(
    UtilityHelper.isNotEmpty(fontName) ? fontName : ""
  );
  const fontSizeClass = getFontSize(fontSize);
  const textColorClass = getTextColor(
    UtilityHelper.isNotEmpty(color) ? color : ""
  );

  if (UtilityHelper.isNotEmpty(fontNameClass)) {
    classes.push(fontNameClass);
  }
  if (UtilityHelper.isNotEmpty(fontSizeClass)) {
    classes.push(fontSizeClass);
  }
  if (UtilityHelper.isNotEmpty(textColorClass)) {
    classes.push(textColorClass);
  }

  return classes.join(" ");
};

const Div: React.FC<Props> = ({
  children,
  className = "",
  role,
  style,
  color = "",
  fontName = "",
  fontSize = "",
}) => {
  const classes: string = fontNameClass(fontName, fontSize, color);
  const mainClass: string | undefined = UtilityHelper.isEmpty(className) && UtilityHelper.isEmpty(classes) ? undefined : `${className} ${classes}`;
  return (
    <div className={mainClass} role={role} style={style}>
      {children}
    </div>
  );
};

export default Div;
